const companies = [
  {
    title: 'Uphold',
    role: 'Senior Backend Engineer',
    skills: 'TypeScript, Go, AWS, Kubernetes',
    period: '2026–Present',
    location: 'London, UK',
  },
  {
    title: 'VeChain',
    role: 'Senior Software / Blockchain Developer',
    skills: 'TypeScript, Solidity, Hardhat, VeChain Protocol',
    period: '2025–2026',
    location: 'London, UK',
  },
  {
    title: 'Serenade',
    role: 'Software / Blockchain Developer',
    skills: 'TypeScript, Go, Next.js, NestJS, Polygon, Solidity, Hardhat',
    period: '2022–2024',
    location: 'Sydney, Australia',
  },
  {
    title: 'Freelance',
    role: 'Software / Blockchain Developer',
    skills: 'TypeScript, Solidity, Hardhat',
    period: '2021–Present',
    location: 'Remote',
  },
  {
    title: 'Rex Software',
    role: 'Software Developer',
    skills: 'TypeScript, JavaScript, React, Laravel, PHP',
    period: '2018–2021',
    location: 'Australia',
  },
  {
    title: 'CSIRO',
    role: 'Software Developer Intern',
    skills: 'Java, MySQL, PostgreSQL',
    period: '2017',
    location: 'Australia',
  },
];

export default companies;
